export const NavbarSM = () => {
  return null;
};
